﻿(() => {
  const formatMoneyFallback = (cents) => {
    const amount = Number(cents || 0) / 100;
    try {
      const currency = window.Shopify?.currency?.active || 'USD';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount).replace(/\.00$/, '');
    } catch (error) { return `$${amount.toFixed(amount % 1 === 0 ? 0 : 2)}`; }
  };
  const getDiscountPercent = (price, compare, fallback) => {
    const preset = Number(fallback || 0);
    if (preset > 0) return preset;
    if (compare > price && compare > 0) return Math.round(((compare - price) / compare) * 100);
    return 0;
  };
  const updateCard = (card, button) => {
    const variantId = button.dataset.variantId;
    const available = button.dataset.variantAvailable === 'true';
    const price = Number(button.dataset.variantPrice || 0);
    const compare = Number(button.dataset.variantCompare || 0);
    const image = card.querySelector('.lumbv-collection-card__image--primary') || card.querySelector('.lumbv-collection-card__image');
    const input = card.querySelector('[data-collection-card-variant-input]');
    const buyNow = card.querySelector('.lumbv-collection-card__buy-now');
    const buyText = card.querySelector('[data-collection-card-buy-text]');
    const addButton = card.querySelector('.lumbv-collection-card__cart');
    const priceCurrent = card.querySelector('[data-collection-card-price-current]');
    const priceCompare = card.querySelector('[data-collection-card-price-compare]');
    const discount = card.querySelector('[data-collection-card-discount]');
    card.querySelectorAll('[data-collection-card-variant]').forEach((variantButton) => {
      const active = variantButton === button;
      variantButton.classList.toggle('is-active', active);
      variantButton.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (input) input.value = variantId;
    if (buyNow) { buyNow.dataset.variantId = variantId; buyNow.disabled = !available; }
    if (addButton) { addButton.disabled = !available; addButton.toggleAttribute('aria-disabled', !available); }
    if (buyText) buyText.textContent = available ? 'Order Now' : 'Sold Out';
    if (priceCurrent) priceCurrent.textContent = button.dataset.variantPriceMoney || formatMoneyFallback(price);
    if (priceCompare) {
      const hasCompare = compare > price;
      priceCompare.classList.toggle('is-hidden', !hasCompare);
      priceCompare.textContent = hasCompare ? (button.dataset.variantCompareMoney || formatMoneyFallback(compare)) : '';
    }
    if (discount) {
      const percent = getDiscountPercent(price, compare, button.dataset.variantDiscountPercent);
      discount.classList.toggle('is-hidden', percent <= 0);
      discount.textContent = percent > 0 ? `-${percent}%` : '';
    }
    if (image && button.dataset.variantImage) {
      image.src = button.dataset.variantImage;
      if (button.dataset.variantSrcset) image.srcset = button.dataset.variantSrcset;
    }
  };
  if (!window.__lumbvCollectionCardBound) {
    window.__lumbvCollectionCardBound = true;
    document.addEventListener('click', (event) => {
      const variantButton = event.target.closest('[data-collection-card-variant]');
      if (variantButton) {
        event.preventDefault();
        const card = variantButton.closest('[data-lumbv-collection-card]');
        if (card) updateCard(card, variantButton);
        return;
      }
    });
  }
})();